export const CookieService = Symbol.for('CookieService');

export interface CookieService {
    match(pattern: RegExp): RegExpMatchArray | null;
}
